import Container from '../Container';
import homeIcon from '@/public/images/icons/home.svg';
import DefaultLink from '../common/default/DefaultLink';
import Image from 'next/image';
import {
  ImagesIconsArrowRightSvg,
  ImagesIconsShareSvg,
} from '@/assets/images_icons.assets';
import ShareModal from '../common/ShareModal';
import { useState } from 'react';
import { usePathname } from 'next/navigation';
import DefaultButton from '../common/default/DefaultButton';
import useTypedTranslation from '@/hooks/useTypedTranslation';
import { CommonEnum } from '@/types/translations/CommonEnum';
import { BlogBreadCrumbsProps } from '@/types/props/components/blogs';
import { BlogEnum } from '@/types/translations/BlogEnum';
import clsx from 'clsx';
export default function BlogBreadCrumbs({
  authorName,
  shareTitle,
  isAuthorsPage,
}: BlogBreadCrumbsProps) {
  const [showShareModal, setShowShareModal] = useState(false);
  const pathname = usePathname();
  const { translate } = useTypedTranslation<CommonEnum>('common');
  const { translate: translateBlog } = useTypedTranslation<BlogEnum>('blog');

  const handleCloseShareModal = () => setShowShareModal(false);

  return (
    <div className="tw-bg-[#EDEDEE80]">
      <Container>
        <div className="tw-flex tw-items-center tw-justify-between tw-py-3">
          <div className="tw-flex tw-items-center child:tw-flex child:tw-items-center child:tw-gap-2">
            <DefaultLink
              href="/"
              aria-label="Go to home page"
              className={clsx(authorName && 'max-fourSevenThree:tw-hidden')}
            >
              <Image
                src={homeIcon}
                width={12}
                height={12}
                alt="Home"
                className="me-1"
              />
              <Image
                src={ImagesIconsArrowRightSvg}
                width={4}
                height={9}
                alt="Arrow right"
                className="me-3"
              />
            </DefaultLink>
            <DefaultLink href="/blog" aria-label="Go to home page">
              <span className="tw-text-slate-gray tw-text-xs tw-font-medium tw-font-plusJakartaSans">
                {translateBlog(BlogEnum.spiritory_blog)}
              </span>
              {Boolean(authorName || isAuthorsPage) && (
                <Image
                  src={ImagesIconsArrowRightSvg}
                  width={4}
                  height={9}
                  alt="Arrow right"
                  className="me-3"
                />
              )}
            </DefaultLink>
            {isAuthorsPage && (
              <DefaultLink href={`/blog/authors`} aria-label="Go to home page">
                <span className="tw-text-text tw-text-xs tw-font-medium tw-font-plusJakartaSans">
                  {translateBlog(BlogEnum.authors)}
                </span>
              </DefaultLink>
            )}
            {authorName && (
              <>
                <DefaultLink
                  href={`/blog/authors`}
                  aria-label="Go to home page"
                >
                  <span className="tw-text-slate-gray tw-text-xs tw-font-medium tw-font-plusJakartaSans">
                    {translateBlog(BlogEnum.authors)}
                  </span>
                  <Image
                    src={ImagesIconsArrowRightSvg}
                    width={4}
                    height={9}
                    alt="Arrow right"
                    className="me-3"
                  />
                </DefaultLink>
                <DefaultLink
                  href={`/blog/${authorName}`}
                  aria-label="Go to home page"
                >
                  <span className="tw-text-text tw-text-xs tw-font-medium tw-font-plusJakartaSans">
                    {authorName}
                  </span>
                </DefaultLink>
              </>
            )}
          </div>
          <DefaultButton
            className="tw-flex tw-items-center tw-justify-center tw-gap-3 tw-text-sm tw-text-text tw-font-medium tw-font-plusJakartaSans tw-border tw-border-solid tw-border-platinum-gray tw-rounded-xl tw-py-2 tw-px-4 tw-bg-transparent tw-transition-all tw-duration-200 hover:tw-bg-gray-100 focus:tw-outline focus:tw-outline-2 focus:tw-outline-blue-500 active:tw-bg-gray-200 disabled:tw-border-gray-300 disabled:tw-text-gray-400 disabled:tw-cursor-not-allowed max-fourSevenThree:tw-px-2"
            onClick={() => setShowShareModal(true)}
          >
            <Image
              src={ImagesIconsShareSvg}
              width={24}
              height={24}
              alt={translate(CommonEnum.share)}
              className="max-fourSevenThree:tw-w-3 max-fourSevenThree:tw-h-3"
            />
            {translate(CommonEnum.share)}
          </DefaultButton>

          <ShareModal
            showShareModal={showShareModal}
            handleCloseShareModal={handleCloseShareModal}
            url={`${process.env.NEXT_PUBLIC_BASE_URL}${pathname}`}
            title={shareTitle}
          />
        </div>
      </Container>
    </div>
  );
}
